import React, { useRef, useEffect, useState } from 'react';
import 'chart.js/auto';
import { Bar } from 'react-chartjs-2';
const StackedChart = ({label,dataBar,dataLine1,dataLine2}) => {
  const chartRef = useRef(null);
  const [chartInstance, setChartInstance] = useState(null);
  useEffect(() => {
    renderChart(); // Render the chart when the component mounts
  }, [label,dataBar,dataLine1,dataLine2]);

  const renderChart = () => {
    // Define your data and options for the chart
    const data = {
      labels: label,
      datasets: [
        {
          label: 'Dataset 1',
          data: dataBar,
          backgroundColor: '#1C485F',
          borderColor: '#1C485F',
          borderWidth: 1,
          barThickness: 20,
          borderRadius: 7.5,
      borderSkipped: 'bottom',

        },
        {
          label: 'Dataset 2',
          data: dataLine1,
          backgroundColor: '#FF3434',
          borderColor: '#FF3434',
          borderWidth: 1,
          type: 'line',
          borderDash: [5, 5],
          pointRadius: 0,
        },
        {
          label: 'Dataset 3',
          data:dataLine2,
          backgroundColor: '#fafafa',
          borderColor: '#53D86A',
          type: 'line',
          borderWidth: 2,
          pointRadius: 0,
          fill: true,
        },
      ],
    };
  
    const options = {
        scales: {
          x: {
            type: 'category', // Use 'category' for categorical data on the x-axis
            grid: {
                display: false, // Set to false to remove grid lines on the y-axis
              },
          },
          y: {
            stacked: true,
            grid: {
                display: false, // Set to false to remove grid lines on the y-axis
              },
          },
        },
        plugins: {
          legend: {
            display: false, // Set to true or false based on your preference
          },
        },
        elements: {
          line: {
            borderWidth: 2, // Customize the line style for line graphs
          },
          point: {
            radius: 0, // Set the point radius to 0 to remove dots
          },
          bar: {
            borderSkipped:'bottom',

          },
        },
       
      };
      
      setChartInstance(
        <Bar data={data} options={options} width={300} height={80} ref={chartRef} />
      );
      

   
  };

  return (
    <div>
      {chartInstance}
    </div>
  );
};

export default StackedChart;
